<template>
  <v-data-table
    :expanded="tableMixin_expandedRows"
    :footer-props="{
      'items-per-page-options': [pagination.per_page],
    }"
    :items-per-page="pagination.per_page"
    :headers="tableMixin_displayedHeaders"
    :items="displayedItems"
    :mobile-breakpoint="0"
    :page="pagination.current_page"
    :server-items-length="pagination.total"
    :class="{ 'content-loading': loading }"
    disable-sort
    @update:page="tableMixin_changePage"
    @click:row="tableMixin_onRowClick"
  >
    <template v-slot:item.image="{ value }">
      <v-img
        v-if="value"
        :src="$backendUrl(value.image_path)"
        :alt="value.original_name"
        height="100px"
        width="100px"
        class="clickable"
        contain
        @click.stop="viewImages(value)"
      />
    </template>

    <template v-slot:item.email="{ item }">
      <a :href="`mailto:${item.email}`" class="link">{{ item.email }}</a>
    </template>
    <template v-slot:item.phone="{ item }">
      <a :href="`tel:${item.phone}`" class="link">{{ item.phone }}</a>
    </template>
    <template v-slot:item.translatedStatus="{ item }">
      <v-chip
        :color="!item.is_published ? 'grey lighten-4' : 'green accent-2'"
        class="text-caption persist-opacity"
        label
        small
      >
        {{ item.translatedStatus }}
      </v-chip>
    </template>
    <template v-slot:item.actions="{ item }">
      <BaseActionMenu :actions="getRowActions(item)" :item="item" />
    </template>
    <template v-slot:expanded-item="{ item }">
      <BaseExpandedTableRow
        :colspan="tableMixin_displayedHeaders.length"
        :headers="tableMixin_hiddenHeaders"
        :item="item"
      >
        <template v-slot:item.email>
          <a :href="`mailto:${item.email}`" class="link">{{ item.email }}</a>
        </template>
        <template v-slot:item.phone>
          <a :href="`tel:${item.phone}`" class="link">{{ item.phone }}</a>
        </template>
        <template v-slot:item.translatedStatus>
          <v-chip
            :color="!item.is_published ? 'grey lighten-4' : 'green accent-2'"
            class="text-caption persist-opacity"
            label
            small
          >
            {{ item.translatedStatus }}
          </v-chip>
        </template>
      </BaseExpandedTableRow>
    </template>
  </v-data-table>
</template>

<script>
import tableMixin from '../mixins/table-mixin';
import BaseActionMenu from './base/BaseActionMenu';
import BaseExpandedTableRow from './base/BaseExpandedTableRow';

export default {
  name: 'ContactTable',

  components: {
    BaseExpandedTableRow,
    BaseActionMenu,
  },

  mixins: [tableMixin],

  props: {
    items: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    disabledItemIds: {
      type: Object,
      default: () => ({}),
    },
    loading: Boolean,
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('image'),
          value: 'image',
        },
        {
          text: this.$t('full_name'),
          value: 'full_name',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('email'),
          value: 'email',
          hidden: 'xsOnly',
        },
        {
          text: this.$t('status'),
          value: 'translatedStatus',
          hidden: 'smAndDown',
        },
        {
          value: 'actions',
          align: 'end',
        },
      ];
    },

    displayedItems() {
      if (!this.items) {
        return [];
      }
      return this.items.map((r) => ({
        ...r,
        translatedStatus: this.$t(
          `contact_status.${r.is_published ? 'published' : 'not_published'}`,
        ),
      }));
    },
  },

  methods: {
    getRowActions() {
      const actions = [
        {
          callback: (p) => this.$emit('edit', p),
          label: this.$t('edit'),
          icon: 'mdi-pencil',
        },
        {
          callback: (p) => this.$emit('delete', p),
          label: this.$t('delete'),
          icon: 'mdi-delete',
        },
      ];
      return actions;
    },

    viewImages(image) {
      this.$emit('click:image', image);
    },
  },
};
</script>
